export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
          联系我们
        </h2>
        <p className="mt-2 text-sm text-foreground-500">投稿 · 咨询 · 意见反馈</p>

        <div className="mt-8 bg-background-50 rounded-2xl p-6 md:p-10">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-14 h-14 rounded-full bg-primary-100 flex items-center justify-center">
              <i className="ri-mail-send-line text-2xl text-primary-600"></i>
            </div>
          </div>
          <h3 className="text-lg font-semibold text-foreground-900 font-heading">
            欢迎投稿与咨询
          </h3>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-lg mx-auto">
            如果您有影视资源推荐、合作意向或任何问题，欢迎通过以下方式联系我们。色影视团队会尽快回复您的每一条信息，共同打造优质的免费观影社区。
          </p>
          <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-foreground-700">
            <span className="flex items-center gap-2">
              <i className="ri-mail-line text-primary-500"></i>
              contact@seying.com
            </span>
            <span className="hidden sm:block text-background-300">|</span>
            <span className="flex items-center gap-2">
              <i className="ri-wechat-line text-primary-500"></i>
              色影视官方
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}